import { Component, OnInit, Input, KeyValueDiffer, KeyValueDiffers, ViewChild, ElementRef, AfterViewInit, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'rotate-media',
    templateUrl: './rotate-media.component.html',
    styleUrls: ['./rotate-media.component.scss'],
    imports: [NgOptimizedImage]
})
export class RotateMediaComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() media: any;
  private customerDiffer: KeyValueDiffer<string, any>;
  @ViewChild('videoPlayer') videoPlayer: ElementRef<HTMLVideoElement>;

  private isViewInitialized = false;

  constructor(private differs: KeyValueDiffers) {
  }

  ngAfterViewInit(): void {
    this.isViewInitialized = true;
    this.loadVideo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Only proceed if the 'media' input has actually changed and the view is ready.
    if (changes.media && this.isViewInitialized) {
      this.loadVideo();
    }
  }
  
  ngOnInit(): void {
    if (this.media) {
      this.customerDiffer = this.differs.find(this.media).create();
    }
  }

  private loadVideo(): void {
    if (!this.videoPlayer?.nativeElement) {
      return; // Exit if the player isn't ready
    }

    const player = this.videoPlayer.nativeElement;

    if (this.media?.type === 'video') {
      // These steps are necessary to ensure that the video player is properly released 
      // and the new source is loaded.
      
      // Forcefully detach the old source to release browser resources.
      player.pause();
      player.src = ''; 
      player.load(); // Some browsers require a load call to process the empty src.

      // Assign the new source.
      player.src = this.media.source;

      // Load the new source and play.
      player.load();
      player.play().catch(error => {
        console.warn('Video autoplay was prevented by the browser.', error);
      });

    } else {
      // If the new media is not a video, ensure the player is stopped and empty.
      player.pause();
      player.src = '';
    }
  }

  ngOnDestroy(): void {
    if (this.videoPlayer?.nativeElement) {
      const player = this.videoPlayer.nativeElement;
      try {
        player.pause();
        player.src = '';
        player.srcObject = null;
        player.load();
      } catch (error) {
        console.warn('Error cleaning up video element:', error);
      }
    }
  }
}
